import providerCatalog from '../providerCatalog';
import type { PlatformCostProviderId } from '../types';
import isPlatformCostProviderId from './isPlatformCostProviderId';

const isManualEntryPlatformCostProviderId = (value: string): value is PlatformCostProviderId =>
    isPlatformCostProviderId(value) && providerCatalog[value].ingestionMode === 'manual_entry';

export default isManualEntryPlatformCostProviderId;
